export const components = {
  emptyState: {
    primaryTitle: 'Дідько!',
    primaryText: 'Тут ще нічого немає…',
    secondaryTitle: 'Жодного результату…',
    secondaryText: 'Прикро казати, але за обраними фільтрами жодного результату…'
  },
  filters: {
    all: 'Усі',
    search: 'Пошук',
    priceRange: 'Діапазон цін {currency}',
    minValue: 'Мінімальне значення {val}!',
    maxValue: 'Максимальне значення {val}!',
    reset: 'Скинути',
    apply: 'Застосувати'
  },
  comments: {
    reply: 'Відповісти',
    loadMore: 'Завантажити ще',
    edited: 'Відредаговано',
    noComments: 'Жодних коментарів',
    leaveFirstComment: 'Залиште перший коментар'
  },
  curtain: {
    close: 'Закрити'
  },
  photoPreview: {
    close: 'Закрити'
  },
  photoCropper: {
    back: 'Назад',
    save: 'Зберегти'
  },
  rightSidebar: {
    in: 'у'
  },
  pushPrompt: {
    title: '“{appName}” хоче надсилати Вам Push-нотифікації ',
    description: 'Нотифікації можуть включати сповіщення, звуки та піктограми.',
    later: 'Запитати пізніше',
    neverLater: 'Не запитувати більше',
    allow: 'Дозволити'
  },
  inAppPush: {
    attachment: 'Вкладення'
  },
  installPrompt: {
    android: {
      install: 'Встановити',
      description: 'Для бездоганної роботи вам не потрібно використовувати браузер. Просто встановіть застосунок прямо тут.',
      press: 'Натисніть',
      andSelect: 'та виберіть',
      orSimply: 'або просто',
      description2: 'натисніть на кнопку нижче',
      notNow: 'Не зараз'
    },
    ios: {
      justTap: 'Натисніть кнопку',
      buttonInBrowser: '«Ще» та оберіть «Поширити»',
      addToHomeScreen: 'Прокрутіть вниз і натисніть «На початковий екран», потім натисніть «Додати»',
      appWillBeInstalled: 'Додаток буде встановлено на ваш пристрій'
    },
    installApp: 'Встановити застосунок',
    useWeb: 'Використовувати браузер'
  },
  footer: {
    more: 'Меню'
  },
  menu: {
    installApp: 'Встановити застосунок',
    menu: 'Меню',
    close: 'Закрити'
  },
  404: {
    whoops: 'Лишенько!',
    description:
      'Здається ця сторінка не існує, або у вас недостатньо прав для її перегляду. Щоб дізнатися більше, зв’яжіться із власником застосунку.',
    ok: 'ОК'
  },
  relatedUsers: {
    seeall: 'Дивитись усі'
  },
  networkingCurtain: {
    'newOneOnOne': 'Нове 1:1',
    'details': 'Деталі',
    'coverMessage': 'Супровідний текст',
    'location': 'Де зустрінемось',
    'duration': 'Тривалість',
    '15min': '15 хв',
    '30min': '30 хв',
    '45min': '45 хв',
    '60min': '60 хв',
    'timeSlot': 'Дата та час',
    'sendInvitation': 'Відправити запрошення',
    'success': 'Успіх',
    'invitationSent':
      'Ви успішно надіслали запрошення на зустріч 1:1. Бажаєте залишитися на цій сторінці чи перейти до всіх запланованих зустрічей 1:1?',
    'seeAll': 'Подивитися всі зустрічі 1:1',
    'stayHere': 'Залишитися тут'
  },
  networking: {
    level: {
      1: 'Ще не готовий до нетворкінгу. Жодної значної активності чи участі.',
      2: 'Низька активність або відсутні ключові деталі профілю.',
      3: 'Профіль заповнений з фото та користувач зараз онлайн, повністю готовий до початку спілкування.',
      4: 'Набирає обертів – ініційовано принаймні одне встановлення контакту за останні 6 годин.',
      5: 'Майстер нетворкінгу – активно відповідає на запити та спілкується з іншими протягом останніх 6 годин.'
    }
  },
  time: {
    days: 'д',
    hours: 'г',
    minutes: 'хв',
    seconds: 'с',
    startsIn: 'через',
    Today: 'Сьогодні',
    today: 'сьогодні',
    Tomorrow: 'Завтра',
    tomorrow: 'завтра',
    Yesterday: 'Вчора',
    yesterday: 'вчора',
    startingNow: 'починається зараз'
  },
  daysMonths: {
    months: "['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень']",
    monthsShort: "['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру']",
    weekdays: "['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота']",
    weekdaysShort: "['Нед', 'Пон', 'Вів', 'Сер', 'Чет', 'П’ят', 'Суб']",
    weekdaysMin: "['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Досягнув рівня “Legend” хоча б один раз, активно спілкуючись та створючи значущі зв’язки.',
    push_description: 'Дозволив push-сповіщення, щоб залишатись на зв’язку та не втратити жодної можливості.',
    leader_description: 'Увійшов у топ 10% в таблиці лідерів хоча б один раз.',
    meetmaster_description: 'Ініціював або відповів як мінімум на один запит на 1:1 зустріч в додатку.',
    connector_description: 'Встановив хоча б три коннекта, використовуючи нетворкінг в додатку.'
  }
}
